var scrollPosition = window.scrollY
var logoContainer = document.getElementById('banner')[0]

window.addEventListener('scroll', function() {
  scrollPosition = window.scrollY

  if (logoContainer !== '') {
    if (scrollPosition >= 480) {
      document.body.classList.add('logo-move')
    } else {
      document.body.classList.remove('logo-move')
    }
  }
})
